import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedBuyItNowButton } from './PdpSharedBuyItNowButton';
import { PdpSharedAddToCartButton } from './PdpSharedAddToCartButton';

import { PdpSharedShoppingButtons_user$key } from './__generated__/PdpSharedShoppingButtons_user.graphql';
import { PdpSharedShoppingButtons_item$key } from './__generated__/PdpSharedShoppingButtons_item.graphql';

const userFragment = graphql`
    fragment PdpSharedShoppingButtons_user on User {
        ...PdpSharedBuyItNowButton_user
        ...PdpSharedAddToCartButton_user
    }
`;

const itemFragment = graphql`
    fragment PdpSharedShoppingButtons_item on Item {
        ...PdpSharedBuyItNowButton_item
        ...PdpSharedAddToCartButton_item
    }
`;

export const PdpSharedShoppingButtons: FC<{
    user: PdpSharedShoppingButtons_user$key | null;
    item: PdpSharedShoppingButtons_item$key;
    skuId?: string;
    quantitySelected?: string;
}> = ({ user: userRef, item: itemRef, skuId, quantitySelected }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);

    return (
        <>
            <PdpSharedBuyItNowButton
                user={user}
                item={item}
                skuId={skuId}
                quantitySelected={quantitySelected}
            />
            <PdpSharedAddToCartButton
                user={user}
                item={item}
                skuId={skuId}
                quantitySelected={quantitySelected}
            />
        </>
    );
};
